export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>The Film</h2>
          <p>
            I highly recommend watching it with the new soundtrack by The
            Cinematic Orchestra in 2002. It has 51 pieces of music that
            vigorously follows the kinetic energy of the film. It really gives
            you a new view of the film and it's many changes.
            <a
              href="https://www.youtube.com/watch?v=cGYZ5847FiI"
              rel="nofollow"
              target="_blank"
            >
              <p style={{ backgroundColor: "#B51A00", marginLeft: "400px" }}>
                YouTube
              </p>
            </a>{" "}
            <a
              href="https://vimeo.com/251988511"
              rel="nofollow"
              target="_blank"
            >
              <div style={{ backgroundColor: "#D6AE72", marginRight: "400px" }}>
                vimeo
              </div>
            </a>
          </p>
        </div>
        <div className="row">
          <iframe
            src="https://commons.wikimedia.org/wiki/File:Man_With_A_Movie_Camera_(Dziga_Vertov,_1929).webm?embedplayer=yes"
            width="800"
            height="600"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>
  );
};
